import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthentifiedPage from "./AuthentifiedPage";
import "../styles/RapportPage.css";
import { useAuth } from "../context/AuthContext";
import { rapportService } from "../services/RapportService";
import { indicateurService } from "../services/IndicateurService";
import IndicateurTableContainer from "../components/IndicateurTableContainer";
import IndicateurChartContainer from "../components/IndicateurChartContainer";

const RapportBuilderPage: React.FC = () => {  
  const { api } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { name, indicateurs, tableName } = location.state || {};
  const [description, setDescription] = useState("");
  const [showPreview, setShowPreview] = useState(true);
  const [indicatorData, setIndicatorData] = useState<Record<number, { meta: any; rows: Record<string, any>[] }>>({});

  useEffect(() => {
    const loadIndicatorData = async () => {
      try{
        setIndicatorData(await indicateurService.loadMultiIdDatas(api,indicateurs));
      }catch(e){
        return;
      }
    };

    loadIndicatorData();
  }, [api, indicateurs]);

  if (!name || !indicateurs) {
    return (
      <AuthentifiedPage>
        <div style={{ padding: 40 }}>Données manquantes pour créer le rapport.</div>
      </AuthentifiedPage>
    );
  }

  const saveRapport = async () => {
    try {
      const insertresult = await rapportService.createRapportWithIndicateurs(api,indicateurs,tableName,description)

      if (!insertresult.success) {
        alert("Erreur lors de la création du modèle de rapport.");
        return;
      }

      navigate("/rapport-modeles", { state: { modele: insertresult.rapport } });
    } catch (error) {
      console.error("Erreur lors de la mise à jour du rapport :", error);
      alert("Erreur lors de la création du modèle de rapport.");
    }
  };

  return (
    <AuthentifiedPage>
      <div style={{ maxWidth: 1000, margin: "20px auto", fontFamily: "Arial" }}>
        <h3>
          Créer un rapport : <span style={{ color: "green" }}>{name}</span>
        </h3>
        <h5>Fenêtre : {tableName}</h5>
        <hr />
        <label style={{ fontWeight: "bold" }}>Description générale :</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Ajouter une introduction ou un résumé..."
          style={{ width: "100%", minHeight: 80, padding: 10, borderRadius: 6, border: "1px solid #ccc", marginBottom: 20 }}
        />
      <div style={{width:"100%",marginBottom:"10vh"}}>
        <div
          onClick={() => setShowPreview(!showPreview)}
          style={{
            cursor: "pointer",
            borderRadius: 6,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 style={{textAlign:"center", margin:"auto", color:"rgba(25,25,25,.8)"}}>Aperçu
          <span style={{ fontSize: 30, marginLeft: "10pt" }}>
            {showPreview ? "▼" : "▶"}
          </span>
          </h3>
        </div>
        {showPreview && (
          <div>
            <div style={{marginBottom: "5vh"}}>
              <h4 style={{ textAlign:"center" ,margin: "5vh 0" }}>Tableau des indicateurs</h4>
              <IndicateurTableContainer indicatorData={indicatorData}/>
            </div>
            <div style={{marginBottom: "5vh"}}>
              <h4 style={{ margin: "5vh 0" }}>Répartition</h4>
              <IndicateurChartContainer indicatorData={indicatorData} chartType="pie"/>
            </div>

            <div style={{marginBottom: "5vh"}}>
              <h4 style={{ marginTop: "5vh 0" }}>Graphique linéaire</h4>
              <IndicateurChartContainer indicatorData={indicatorData} chartType="area"/>
            </div>
          </div>
        )}
        </div>

        {/* Bouton uniformisé */}
        <button
          className="btn-import"
          onClick={saveRapport}
        >          
        Enregistrer le modèle
        </button>
      </div>
    </AuthentifiedPage>
  );
};

export default RapportBuilderPage;
